import { render, staticRenderFns } from "./activeCard.vue?vue&type=template&id=ab4c89c2&scoped=true"
import script from "./activeCard.vue?vue&type=script&lang=js"
export * from "./activeCard.vue?vue&type=script&lang=js"
import style0 from "./activeCard.vue?vue&type=style&index=0&id=ab4c89c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4c89c2",
  null
  
)

export default component.exports